import {
    ButtonFixedFooterLayout,
    ButtonLayout,
    ButtonPrimary,
    Callout,
    IconInformationUserRegular,
    PhoneNumberField,
    Text3,
    skinVars,
} from '@telefonica/mistica';
import React, { useState } from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import { TrackingEvents } from '../../../utils/dataTransformation/tracking';
import Stopper from '../../../components/Stopper';
import { managementEnvironment } from '../../../utils/dataTransformation/environments';
import { useSearchParams } from 'react-router-dom';

const LoginMobileConnect: React.FC = () => {
    const loginDisabledMc = managementEnvironment().REACT_APP_STOPPER_LOGIN_MC_DISABLED;
    const { t } = useTranslation();
    const [number, setNumber] = useState('');
    const [params] = useSearchParams();
    const { trackingUserInteraction } = new TrackingEvents();

    const handleInputChange = (event: any) => {
        setNumber(event);
    };

    // TODO: Set redirect uri based on clientId
    const loginMobileConnect = (number: string) => {
        // Validate mobile number
        if (number.length != 9) {
            return;
        }
        const nonce = uuidv4();
        const state = params.get('state');
        // Save mobile and state so they can be retrieved later on mobile connect callback
        window.localStorage.setItem('mc-number', number);
        // Login hint example (mobile country prefix is important): login_hint=MSISDN:34625625625
        window.location.href = `${process.env.REACT_APP_LOGIN_MC_URL}&client_id=${process.env.REACT_APP_LOGIN_MC_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_LOGIN_MC_CALLBACK}&state=${state}&nonce=${nonce}&login_hint=MSISDN:34${number}`;
    };

    if (loginDisabledMc) {
        return <Stopper></Stopper>;
    } else {
        return (
            <div className='login-page'>
                <div className='login-page__title'>
                    <Text3 regular>{t('contentLoginTitle')}</Text3>
                </div>
                <div className='login-page__input'>
                    <PhoneNumberField
                        label={t('contentLoginInputLabel')}
                        name='number'
                        prefix='+34'
                        onChangeValue={handleInputChange}
                    ></PhoneNumberField>
                </div>
                <div className='login-page__button'>
                    <ButtonFixedFooterLayout>
                        <ButtonLayout align='full-width'>
                            <ButtonPrimary
                                onPress={() => {
                                    trackingUserInteraction('mobile_conect_tapped');
                                    loginMobileConnect(number);
                                }}
                                disabled={number.length != 9}
                            >
                                {t('contentLoginButton')}
                            </ButtonPrimary>
                        </ButtonLayout>
                    </ButtonFixedFooterLayout>
                </div>
                <div className='login-page__callout'>
                    <Callout
                        icon={<IconInformationUserRegular color={skinVars.colors.brand} />}
                        description={t('descriptionCalloutLoginMobileConnect')}
                    />
                </div>
            </div>
        );
    }
};

export default LoginMobileConnect;
